import clx from 'classnames';
import React, { useState } from 'react';

import { Affix } from 'antd';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

interface StyledProps {
  paddingSide?: number;
}

const StyledButtonRowCardFooter = styled.div<StyledProps>`
  z-index: 9;
  position: relative;
  display: block;
  padding: ${props => props.paddingSide ?? 24}px;
  padding-top: 12px;
  padding-bottom: 12px;

  // bordo divisore
  border-top: 1px solid ${props => props.theme.colorSplit};
  &.affix-top {
    border-top: none;
    border-bottom: 1px solid ${props => props.theme.colorSplit};
  }
  &.no-divider,
  &.affix-top.no-divider {
    border-top: none;
    border-bottom: none;
  }

  // correggiamo padding se l'elemento in una StyledResponsiveCard
  &.affix-top {
    .responsive-card.has-padding & {
      margin: -24px;
      margin-bottom: 0;
      ${down('sm')} {
        margin: -12px;
        margin-bottom: 0;
      }
    }
  }
  // correggiamo padding se l'elemento in una StyledResponsiveCard
  .responsive-card.has-padding & {
    margin: -24px;
    margin-top: 0;
    ${down('sm')} {
      margin: -12px;
      margin-top: 0;
    }
  }
`;
const ButtonRowCardFooterContent = styled.div`
  width: 100%;
  position: relative;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const ButtonRowBackdropFilter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  /* ‹.white (default) */
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(4px);
  &.on-page-background {
    background-color: rgba(242, 246, 250, 0.75);
  }
  &.affixed {
    opacity: 1;
  }
`;

export interface ButtonRowCardFooterProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Per rimuovere il bordo superiore */
  removeDivider?: boolean;
  /** Padding per il contenuto (pulsanti) */
  // padding?: number;
  /** Se true, al momento dell'affix, il colore di sfondo
   * viene impostato al grigio del background di pagina */
  onPageBackgroud?: boolean;
  /** per differenziare il Padding per il contenuto (pulsanti) */
  paddingSide?: number;
  /** per differenziare il Padding per il contenuto (pulsanti) */
  affixTop?: boolean;
}

/**
 * Container per i pulsanti Salva etc posizionati nel Footer della Card
 * con funzionalita di Affix per renderli sempre presenti alla fine della Card
 *
 * È possibile specificare un padding per il contenuto (pulsanti)
 *
 * I pulsanti saranno posizionati a destra con un bordo superiore
 * se non viene specificato il parametro removeDivider
 */
export function ButtonRowCardFooter(props: ButtonRowCardFooterProps) {
  const {
    children,
    className,
    removeDivider,
    onPageBackgroud,
    affixTop,
    paddingSide,
    ...otherProps
  } = props;
  const [affixed, setAffixed] = useState<boolean | undefined>(undefined);

  return (
    <Affix
      offsetBottom={affixTop ? undefined : 0}
      offsetTop={affixTop ? 0 : undefined}
      onChange={a => setAffixed(a)}
    >
      <StyledButtonRowCardFooter
        paddingSide={paddingSide ?? 24}
        {...otherProps}
        className={clx(className, {
          'no-divider': removeDivider,
          affixed: affixed,
          'affix-top': affixTop,
        })}
      >
        <div>
          <ButtonRowBackdropFilter
            className={clx({
              'on-page-background': onPageBackgroud,
              affixed: affixed,
            })}
          />
          <ButtonRowCardFooterContent>{children}</ButtonRowCardFooterContent>
        </div>
      </StyledButtonRowCardFooter>
    </Affix>
  );
}
